import React from 'react';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="border-t border-[#f4ede3]/10 bg-[#0d0a08] px-6 py-20 text-[#b8ac9c] sm:px-12">
      <div className="mx-auto max-w-6xl">
        {/* Big brand mark */}
        <div className="mb-16 text-center">
          <p className="font-display text-[clamp(3.5rem,12vw,9rem)] font-black leading-none tracking-[-0.03em] text-[#f4ede3]/10">
            VIBE
          </p>
          <p className="font-display -mt-3 text-2xl italic text-[#f2a33c] sm:-mt-6">café</p>
        </div>

        <div className="mb-14 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* About */}
          <div>
            <h3 className="font-display text-xl font-semibold text-[#f4ede3]">Vibe Café</h3>
            <p className="font-body mt-3 text-sm leading-relaxed">
              Pottstown's creative social innovation hub where community, art, and culture collide.
            </p>
            <div className="mt-5 flex gap-4">
              <a href="#" aria-label="Facebook" data-testid="footer-facebook-link" className="transition-colors hover:text-[#f2a33c]">
                <Facebook size={20} />
              </a>
              <a href="#" aria-label="Instagram" data-testid="footer-instagram-link" className="transition-colors hover:text-[#f2a33c]">
                <Instagram size={20} />
              </a>
              <a href="#" aria-label="Twitter" data-testid="footer-twitter-link" className="transition-colors hover:text-[#f2a33c]">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs font-semibold uppercase tracking-[0.25em] text-[#f4ede3]">Quick Links</h4>
            <ul className="font-body mt-4 space-y-2 text-sm">
              {[
                ['Services', '#services'],
                ['Menu', '#menu'],
                ['Virtual Tour', '#virtual-tour'],
                ['Events', '#events'],
                ['Book Space', '#booking']
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="transition-colors hover:text-[#f2a33c]">
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a href="/admin" data-testid="footer-admin-link" className="font-semibold text-[#f2a33c] transition-colors hover:text-[#ff9a40]">
                  Admin
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-body text-xs font-semibold uppercase tracking-[0.25em] text-[#f4ede3]">Contact</h4>
            <ul className="font-body mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-[#f2a33c]" />
                249 High St, Pottstown, PA
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="shrink-0 text-[#f2a33c]" />
                <a href="tel:+14843738016" className="transition-colors hover:text-[#f2a33c]">484-373-8016</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="shrink-0 text-[#f2a33c]" />
                <a href="mailto:thevibe249@gmail.com" className="transition-colors hover:text-[#f2a33c]">thevibe249@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-body text-xs font-semibold uppercase tracking-[0.25em] text-[#f4ede3]">Cafe Hours</h4>
            <div className="font-body mt-4 space-y-2 text-sm">
              <div className="flex items-start gap-3">
                <Clock size={16} className="mt-0.5 shrink-0 text-[#f2a33c]" />
                <div>
                  <p className="font-semibold text-[#f4ede3]">Mon – Thu, Sat</p>
                  <p>10:00 AM – 6:00 PM</p>
                  <p className="mt-2 font-semibold text-[#f4ede3]">Friday</p>
                  <p>11:00 AM – 7:00 PM</p>
                </div>
              </div>
              <p className="text-xs">Space rentals available outside cafe hours.</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="font-body border-t border-[#f4ede3]/10 pt-8 text-center text-sm">
          <p className="mb-2">
            Powered by{' '}
            <a
              href="https://berezilient.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#f4ede3] transition-colors hover:text-[#f2a33c]"
            >
              BeRezilient
            </a>
          </p>
          <p className="text-xs">&copy; {new Date().getFullYear()} Vibe Cafe · 249 High St, Pottstown, PA · All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
